import GeneralActionTypes from "./general.types";

export const isEditDetailsStart = (isEdit: any) => ({
  type: GeneralActionTypes.IS_EDIT_DETAILS_START,
  payload: isEdit,
});

export const isOpenCanvasStart = (isOpen: any) => ({
  type: GeneralActionTypes.IS_OPEN_OFFCANVAS_START,
  payload: isOpen,
});

/** ***************** GET COUNTRY START *********************** */
export const getCountryListStart = () => ({
  type: GeneralActionTypes.GET_COUNTRY_LIST_START,
});

export const getCountryListSuccess = (successData: any) => ({
  type: GeneralActionTypes.GET_COUNTRY_LIST_SUCCESS,
  payload: successData,
});

export const getCountryListFailure = (failureData: any) => ({
  type: GeneralActionTypes.GET_COUNTRY_LIST_FAILURE,
  payload: failureData,
});

export const getCountryListResponseResetStart = () => ({
  type: GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_RESET,
});

export const getCountryListResponseChanged = () => ({
  type: GeneralActionTypes.GET_COUNTRY_LIST_RESPONSE_CHANGED,
});
/** ***************** GET COUNTRY END *********************** */

/** ***************** FETCH VERSION START *********************** */
export const fetchPincodeDetailsStart = (credential: any) => ({
  type: GeneralActionTypes.FETCH_PINCODE_DETAILS_START,
  payload: credential,
});

export const fetchPincodeDetailsSuccess = (successData: any) => ({
  type: GeneralActionTypes.FETCH_PINCODE_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchPincodeDetailsFailure = (failureData: any) => ({
  type: GeneralActionTypes.FETCH_PINCODE_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchPincodeDetailsResponseResetStart = () => ({
  type: GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_RESET,
});

export const fetchPincodeDetailsResponseChanged = () => ({
  type: GeneralActionTypes.FETCH_PINCODE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH VERSION END *********************** */

/**************FETCH  COUNTRY LIST ************************/
export const fetchCountryListStart = (fetchBranch: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_START,
  payload: fetchBranch,
});

export const fetchCountryListSuccess = (successData: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_SUCCESS,
  payload: successData,
});

export const fetchCountryListFailure = (failureData: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_FAILURE,
  payload: failureData,
});

export const fetchCountryListResetStart = () => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_RESPONSE_RESET,
});

export const fetchCountryListResponseChanged = () => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_RESPONSE_CHANGED,
});
/**************FETCH COUNTRY LIST ************************/

/**************FETCH  COUNTRY STATE LIST ************************/
export const fetchCountryStateListStart = (fetchBranch: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_START,
  payload: fetchBranch,
});
export const fetchCountryStateListSuccess = (successData: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_SUCCESS,
  payload: successData,
});

export const fetchCountryStateListFailure = (failureData: any) => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_FAILURE,
  payload: failureData,
});

export const fetchCountryStateListResetStart = () => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_RESPONSE_RESET,
});

export const fetchCountryStateListResponseChanged = () => ({
  type: GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_RESPONSE_CHANGED,
});

/**************FETCH  COUNTRY STATE LIST ************************/

/**************FETCH  STATE CITY LIST ************************/
export const fetchStateCityListStart = (fetchBranch: any) => ({
  type: GeneralActionTypes.FETCH_STATE_CITY_LIST_START,
  payload: fetchBranch,
});
export const fetchStateCityListSuccess = (successData: any) => ({
  type: GeneralActionTypes.FETCH_STATE_CITY_LIST_SUCCESS,
  payload: successData,
});

export const fetchStateCityListFailure = (failureData: any) => ({
  type: GeneralActionTypes.FETCH_STATE_CITY_LIST_FAILURE,
  payload: failureData,
});

export const fetchStateCityListResetStart = () => ({
  type: GeneralActionTypes.FETCH_STATE_CITY_LIST_RESPONSE_RESET,
});

export const fetchStateCityListResponseChanged = () => ({
  type: GeneralActionTypes.FETCH_STATE_CITY_LIST_RESPONSE_CHANGED,
});

/**************FETCH  STATE CITY LIST ************************/
